import HtmlIcon from "../../images/html-1.svg";
import CssIcon from "../../images/css-3.svg";
import JsIcon from "../../images/javascript-1.svg";
import ReactIcon2 from "../../images/react-1.jpg";
import reduxIcon from "../../images/Thewm-01-01.jpg";
import wordPressIcon from "../../images/W.png";
import DesignVerse from "../../images/DesignVerse.png";
import CasperWeb from "../../images/CaseperWeb.png";
import weatherImage from "../../images/weatherImage.png";
import eCommerce from "../../images/e-commerce-big.png";
import yummy from "../../images/yummy-big.png";
import NextIcon from "../../images/next-icon.png";
import CosmicImage from "../../images/cosmic-big.png";
import adOnVerseImage from "../../images/adOnVerse_968x476.png";
import hamlegalImage from "../../images/hamlegal.png";
import LearnFlowImage from "../../images/learnFlow.png";
import AdOnVerseAppImage from "../../images/adonverseApp.png";
import KotlinIcon from "../../images/k3.png";
export const images = [
  {
    id: "adOnVerseApp",
    image: AdOnVerseAppImage,
  },
  {
    id: "adOnVerse",
    image: adOnVerseImage,
  },
  {
    id: "hamlegal",
    image: hamlegalImage,
  },
  {
    id: "ShopClothes",
    image: eCommerce,
  },
  {
    id: "Yummy",
    image: yummy,
  },
  {
    id: "LearnFlow",
    image: LearnFlowImage,
  },
  {
    id: "cosmic-fish",
    image: CosmicImage,
  },
  { id: "DesignVerse", image: DesignVerse },
  // { id: "TodoApp", image: ToDoApp },
  { id: "CasperWeb", image: CasperWeb },
  // {
  //   id: "PrayerTimes",
  //   image: SyriaPrayerTimes,
  // },
  {
    id: "weatherApp",
    image: weatherImage,
  },
];

export const stacks = [
  { id: "html", icon: HtmlIcon },
  { id: "css", icon: CssIcon },
  { id: "js", icon: JsIcon },
  { id: "wordpress", icon: wordPressIcon },
  { id: "react", icon: ReactIcon2 },
  { id: "redux", icon: reduxIcon },
  { id: "kotlin", icon: KotlinIcon },

  { id: "next", icon: NextIcon },
];
export const slideNames = [
  {
    id: "adOnVerseApp",
    title: "ADONVERSE APP",
    link: "https://play.google.com/store/apps/details?id=com.adonverse.adonverseapp&hl=en",
  },
  {
    id: "adOnVerse",
    title: "ADONVERSE",
    link: "https://www.adonverse.com",
  },
  {
    id: "hamlegal",
    title: "HAMLEGAL",
    link: "https://hamlegal.net/",
  },
  {
    id: "ShopClothes",
    title: "SHOP.CO",
    link: "https://clothes-ecommerce-jr.netlify.app/",
  },
  {
    id: "Yummy",
    title: "YUMMY",
    link: "https://yummy-food-chi.vercel.app/",
  },
  {
    id: "LearnFlow",
    title: "LEARN FLOW",
    link: "https://learn-flow-rouge.vercel.app/",
  },
  {
    id: "cosmic-fish",
    title: "COSMIC FISHING",
    link: "https://cosmic-fishing.vercel.app/",
  },
  {
    id: "DesignVerse",
    title: "DESIGNVERSE",
    link: "https://taim-gr.github.io/DesignVerse/",
  },
  // {
  //   id: "TodoApp",
  //   title: "Todo App",
  //   link: "https://todo-jr.netlify.app/",
  // },
  {
    id: "CasperWeb",
    title: "CASPER WEB",
    link: "https://taim-gr.github.io/Casper/",
  },

  // {
  //   id: "PrayerTimes",
  //   title: "Prayer Times",
  //   link: "https://syria-prayer-times.netlify.app/",
  // },
  // {
  //   id: "GuessWordGame",
  //   title: "Guess Word",
  //   link: "https://taim-gr.github.io/Guess-The-Word-Game/",
  // },
  {
    id: "weatherApp",
    title: "WEATHER APP",
    link: "https://arab-capitals-weather.netlify.app/",
  },
];
